import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import {
  AdvancedFilterDataSchema,
  VALID_PAGE_SIZES,
} from "@redotech/redo-model/views/views";
import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const searchPickSessions = {
  name: "searchPickSessions" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    pageNumber: z.number(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    pickSessions: z.array(PickSessionSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export type SearchPickSessionsInput = z.infer<typeof searchPickSessions.input>;
